import React from "react"
import Header from "../component/Header"
import { Link } from "react-router-dom"

const NotFound = () => {
    return (
        <>
            <Header />
            <div className="max-w-2xl mx-auto md:mt-32 mt-20 px-4 text-center">
                <h1 className="text-4xl font-bold text-sky-600">Page not found</h1>
                <p className="mt-4 text-slate-600 text-lg">
                    The page you are looking for does not exist or may have been moved.
                </p>
                <Link
                    to="/"
                    className="inline-block mt-8 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 px-8 py-3 text-sm font-semibold text-white shadow-md hover:brightness-95"
                >
                    Return to home
                </Link>
            </div>
        </>
    )
}

export default NotFound
